<!-- Paying mentee -->
<template>
  <div>
    <div class="referral-con referral-con-intro">
      <div>
        <h1>Paying mentee</h1>
        <div class="intro-con">
          Please send us the contact information of the potential student who is interested in studying outside of China. We reward <span>$300 USD</span> for every successfully signed student.
          <br />
          <br />
          Status Explanation
          <br />
          <br />
          Pending : We successfully received your entry and it is in the process.<br />
          Failed :Unable to contact the student / student already referred by other channels / student has no intention to study abroad, etc.<br />
          Successful entry : Student with study abroad intention successfully contacted by ZLR Valeon.<br />
          Signed : Student signs the service agreement with ZLR Valeon.<br />
          Not Signed : the student stated he/she is no interested in signing with ZLR Valeon.
        </div>
        <referral-input type="CLIENT"
                        @on-success="subSuccess"></referral-input>
      </div>
    </div>
    <referral-list type="CLIENT"
                   ref='list'></referral-list>
  </div>
</template>
<script>
// components
import ReferralInput from './referral-input'
import ReferralList from './referral-list'
export default {
  name: 'referral-pay',
  components: {
    ReferralList,
    ReferralInput
  },
  data () {
    return {

    }
  },
  computed: {},
  mounted () { },
  methods: {
    // 提交成功
    subSuccess () {
      this.$refs['list'].getPageList()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
